import React from 'react'
import { Provider } from 'react-redux'
import createStore from './src/state/store'
import { GraphQL, GraphQLProvider } from 'graphql-react'
import FavouritesProvider from './src/context/favourites'
import ReactDOM from 'react-dom'
import { extractVehicleDataFromPath } from './lib/vehicle-extractor'

// Zero config GraphQL client that manages the cache.
const graphql = new GraphQL()

export const wrapRootElement = ({ element }) => {
  const store = createStore()
  const ConnectedRootElement = (
    <GraphQLProvider graphql={graphql}>
      <FavouritesProvider>
        <Provider store={store}>{element}</Provider>
      </FavouritesProvider>
    </GraphQLProvider>
  )
  return ConnectedRootElement
}

// GA - Enhanced with vehicle data while preserving existing functionality
export const onRouteUpdate = ({ location }) => {
  // Extract vehicle data from URL (non-intrusive enhancement)
  const vehicleData = extractVehicleDataFromPath(location.pathname)

  // Push vehicle data to GTM data layer (enhancement only)
  if (window.dataLayer && (vehicleData.make || vehicleData.model)) {
    window.dataLayer.push({
      event: 'vendorVehiclePageView',
      make: vehicleData.make || undefined,
      model: vehicleData.model || undefined,
      page: location ? location.pathname + location.search + location.hash : undefined
    })
  }

  if (typeof ga === `function`) {
    if (
      location &&
      typeof window.excludeGAPaths !== `undefined` &&
      window.excludeGAPaths.some((rx) => rx.test(location.pathname))
    ) {
      return
    }

    // Set GA custom dimensions for vehicle data (enhancement only)
    if (vehicleData.make) {
      window.ga('set', 'dimension1', vehicleData.make)
    }
    if (vehicleData.model) {
      window.ga('set', 'dimension2', vehicleData.model)
    }

    // Original GA pageview logic (unchanged)
    window.ga(
      'set',
      'page',
      location ? location.pathname + location.search + location.hash : undefined
    )
    window.ga('gtm1.send', 'pageview')
  }
}

export const replaceHydrateFunction = () => {
  return (element, container) => {
    const root = ReactDOM.createRoot(container)
    root.render(element)
  }
}
